import { filterPins, toggleMapLayers, toggleTerminator } from "./map";

const onFilterChange = () => {
  const filters = []; // Initialize an empty array to store selected filters

  // Loop through each checkbox and add the value to the filters array if it's checked
  document.querySelectorAll('.facility-filter input[type="checkbox"]').forEach(checkbox => {
    if (checkbox.checked) {
      filters.push(checkbox.getAttribute('data-value')); // Push the value attribute to the filters array
    }
  });

  filterPins(filters); // Pass the array of filters to the filterPins function
};


const onToggleLayer = () => {
  const checkbox = document.getElementById('toggleLayerCheckbox');
  toggleMapLayers(checkbox.checked); // Pass the checkbox state to the function
};

const onToggleTerminator = () => {
  const checkbox = document.getElementById('toggleTerminatorCheckbox');
  toggleTerminator(checkbox.checked); // Pass the checkbox state to the function
};


// Function to reset all filters
const resetAllFilters = () => {
  location.reload(); // Reload the page to reset everything to initial state
};

// Add event listener to the Reset Filters button
document.getElementById('resetFiltersButton').addEventListener('click', resetAllFilters);


window.onFilterChange = onFilterChange;
window.onToggleLayer = onToggleLayer;
window.onToggleTerminator = onToggleTerminator;

